var ViewController = require("./ViewController"),
    kind           = require("enyo/kind");

module.exports = kind(/** @lends  app.core.PopupContentController.prototype */ {

    /**
     * @private
     */
    name: "app.core.PopupContentController",

    /**
     * @private
     */
    kind: ViewController,

    /**
     * @public
     */
    popup: null,

    /**
     * Set the initial app state before executing the activation. Extend or
     * override as needed.
     *
     * @protected
     */
    resetAppState: function() {
        var $appState = this.app.$.state;

        $appState.resetMediaDetailsState();
        $appState.set("mediaDetailsController", this);
    },

    /**
     * Build an activation fingerprint. Extend or override as needed.
     *
     * @param    {Object}  params  The parameters
     * @returns  {Object}  The fingerprint
     * @protected
     */
    buildActivationFingerprint: function(params) {
        var $authService = this.app.$.authService;

        return {
            params:         params,
            userId:         ($authService.get("user") || {}).id || null,
            userPrivileges: $authService.getUserPrivileges()
        };
    },

    /**
     * @param  {enyo.Control}  ViewKind  The view kind
     * @protected
     */
    updateView: kind.inherit(function(sup) {
        return function() {
            sup.apply(this, arguments);
            this.popup.resize();
        };
    }),

    /**
     * @private
     */
    destroy: kind.inherit(function(sup) {
        return function() {
            var $appState = this.app.$.state;

            sup.apply(this, arguments);

            // Remove ourselves as mediaDetailsController if we're still listed
            // as such
            if ($appState.get("mediaDetailsController") === this) {
                $appState.resetMediaDetailsState();
            }
        };
    })

});
